export default __webpack_public_path__ + "static/roman-mykytka-a3b22dd57b0eccc70121de5208dc184d.png";